import type { MeetingPageResponse } from '@wundo/shared/meetingPage.ts';
import { m } from '@/paraglide/messages.js';

/**
 * What the meeting is called wherever it is drawn.
 *
 * A calendar entry can genuinely have no title, and both the page's heading and
 * the panel's own label still need one — so the fallback is written once, here.
 */
export function meetingPageTitle(page: MeetingPageResponse): string {
  return page.meeting.title?.trim() || m.agenda_untitled();
}
